export default __webpack_public_path__ + "static/media/change-link-img-cn.aa0ea4e2.svg";